<template>
  <div class="app-container">
    <el-form :inline="false" label-position="top" size="small">
      <el-row :gutter="20">
        <el-col :span="7">
          <!--上传时间-->
          <el-form-item prop="timeType">
            <template slot="label">
              <div class="selectLabel">
                <el-select v-model="queryForm.params.timeType" :style="IsWidth01">
                  <el-option key="1" :label="$t('fixDutyFine.reportTime')" :value="1" />
                  <el-option key="2" :label="$t('fixDutyFine.approvalTime')" :value="2" />
                </el-select>
              </div>
            </template>
            <el-date-picker
              v-model="timeValue"
              :clearable="false"
              :default-time="['00:00:00', '23:59:59']"
              :format="$i18n.locale == 'zh' ? zhDate : ptDate"
              :placeholder="$t('newOrder.SelectDatetime')"
              range-separator="~"
              style="width: 100%"
              type="datetimerange"
              value-format="yyyy-MM-dd HH:mm:ss"
            />
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('fixDutyFine.eventType')">
            <!-- 事件类型 -->
            <el-select v-model="queryForm.params.eventType" clearable style="width: 100%">
              <el-option key="1" :label="$t('fixDutyFine.abnormalEvent')" :value="1" />
              <el-option key="2" :label="$t('fixDutyFine.theftEvent')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('fixDutyFine.abnormalityType')">
            <!-- 异常类型 -->
            <el-select
              v-model="queryForm.params.exceptionTypeList"
              filterable
              multiple
              style="width: 100%"
            >
              <el-option
                v-for="item in exceptionTypeList"
                :key="item.type"
                :label="item.typeName"
                :value="item.type"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$t('GlobalSetObj.status')">
            <!--状态-->
            <el-select v-model="queryForm.params.approveStatusList" multiple style="width: 100%">
              <el-option key="1" :label="$t('fixDutyFine.pendingApproval')" :value="0" />
              <el-option key="2" :label="$t('customerManagements.approved')" :value="1" />
              <el-option key="3" :label="$t('home.unapplivefail')" :value="2" />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <!--  上报大区 -->
          <el-form-item :label="$t('fixDutyFine.reportingRegion')">
            <el-select
              v-model="queryForm.params.regionId"
              :placeholder="$t('placeOrder.pleaseChoose')"
              clearable
              filterable
              style="width: 100%"
            >
              <el-option
                v-for="item in regionList"
                :key="item.id"
                :label="item.zhName + '（' + item.puName + '）'"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <!-- 上报人员 -->
        <el-col :span="5">
          <el-form-item :label="$t('fixDutyFine.reportingPersonnel')">
            <el-select
              v-model="queryForm.params.reportUser"
              :placeholder="$t('GlobalSetObj.pleaseChoose')"
              :remote-method="getCustomerPage"
              clearable
              filterable
              remote
              reserve-keyword
              style="width: 100%"
              @visible-change="handleVisibleChange"
            >
              <el-option
                v-for="item in userList"
                :key="item.id"
                :label="item.username"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="11">
          <div style="margin-top: 28px">
            <!--搜索-->
            <el-button
              icon="el-icon-search" size="small" type="primary"
              @click="enterSearch"
            >{{ $t('newOrder.search') }}
            </el-button>
            <!--重置-->
            <el-button
              icon="el-icon-refresh-left" size="small" type="info"
              @click="resetForm"
            >{{ $t('newOrder.reset') }}
            </el-button>
          </div>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-bottom: 10px">
      <el-button
        v-permit:remove="'btn:exceptionReporting:reportedEvent'"
        size="small"
        type="primary"
        @click="clickEvent"
      >{{ $t('fixDutyFine.reportedEvent') }}
      </el-button>
    </div>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')"
        align="center"
        fixed="left"
        type="index"
        width="80"
      />
      <el-table-column
        v-for="(item, index) in tableHeaderList"
        :key="index"
        :align="item.cloCenter"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <div v-if="item.prop === 'approveStatus'">
            <el-tag v-if="scope.row.approveStatus === 0">
              {{ scope.row.approveStatusName }}
            </el-tag>
            <el-tag v-if="scope.row.approveStatus === 1" type="success">
              {{ scope.row.approveStatusName }}
            </el-tag>
            <el-tag v-if="scope.row.approveStatus === 2" type="danger">
              {{ scope.row.approveStatusName }}
            </el-tag>
          </div>
          <div
            v-else-if="item.prop === 'waybillQuantity'"
            class="verifier"
            @click="clickDown(scope.row)"
          >
            {{ scope.row.waybillQuantity }}
          </div>
          <div v-else class="multiline">
            {{ scope.row[item.prop] !== null ? `${scope.row[item.prop]}` : '--' }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        :label="$t('GlobalSetObj.operate')"
        align="center"
        fixed="right"
        prop="varianceNumber"
        width="110"
      >
        <template slot-scope="scope">
          <div class="flx-around">
            <i
              v-if="scope.row.approveStatus !== 1"
              v-permit:remove="'btn:exceptionReporting:toApprove'"
              class="iconfont icon-a-ziyuan87 verifier"
              @click="toApprove(scope.row)"
            />
            <i
              class="iconfont icon-chakan verifier"
              style="font-size: 22px"
              @click="seeDetail(scope.row)"
            />
            <i
              v-if="scope.row.approveStatus !== 1"
              v-permit:remove="'btn:exceptionReporting:toEdit'"
              class="iconfont icon-a-zu255 verifier"
              style="font-size: 17px"
              @click="toEdit(scope.row)"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!--  分页  -->
    <el-pagination
      :current-page="queryForm.pageNumber"
      :page-size="queryForm.pageSize"
      :page-sizes="[10, 20, 50, 100]"
      :total="queryForm.total"
      background
      layout="total, sizes, prev, pager, next, jumper"
      style="margin: 10px 0; float: right"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
    <reportEvent
      ref="reportEventRef"
      :exception-type-list="exceptionTypeList"
      @search="enterSearch"
    />
    <eventApproval ref="eventApprovalRef" @search="enterSearch" />
  </div>
</template>

<script>
import { getLgAreaListData, regionQueryList } from '@/api/orderApi';
import reportEvent from './component/reportarEventos.vue';
import eventApproval from './component/eventApproval.vue';
import dayjs from 'dayjs';
import {
  exportWaybillDownload,
  getExceptionReportPage,
  getExceptionType
} from '@/api/bulkExpressApi';
import { getUserPage } from '@/api/customer';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'ExceptionReporting',
  components: {
    reportEvent,
    eventApproval
  },
  data() {
    return {
      sitesByRegionAndState: {},
      regionList: [],
      // 是否格式化成巴西时间
      isTormat: false,
      zhDate: 'yyyy-MM-dd HH:mm:ss',
      ptDate: 'dd-MM-yyyy HH:mm:ss',
      timeValue: [],
      queryForm: {
        pageSize: 10,
        pageNumber: 1,
        total: 0,
        params: {
          inputValue: '',
          timeType: 1,
          eventType: '',
          exceptionTypeList: [],
          approveStatusList: [],
          regionId: '',
          reportUser: ''
        }
      },
      tableData: [],
      tableHeaderList: [
        {
          label: this.$t('fixDutyFine.reportTime'),
          prop: 'reportTime',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.eventCategory'),
          prop: 'eventTypeName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.abnormalityType'),
          prop: 'exceptionTypeName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('trajectory.state'),
          prop: 'approveStatus',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.abnormalityLevel'),
          prop: 'exceptionLevelName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.reportingRegion'),
          prop: 'regionName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.affectedPackageCount'),
          prop: 'waybillQuantity',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.estimatedFinancialLoss'),
          prop: 'financeLoss',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.casualtyCount'),
          prop: 'lossPeopleQuantity',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.reportingPersonnel'),
          prop: 'reportUserName',
          cloWidth: 160,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.abnormalityDescription'),
          prop: 'exceptionDetail',
          cloWidth: 110,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.approver'),
          prop: 'approveUserName',
          cloWidth: 150,
          cloCenter: 'center'
        },
        {
          label: this.$t('fixDutyFine.approvalTime'),
          prop: 'approveTime',
          cloWidth: 120,
          cloCenter: 'center'
        }
      ],
      dialogVisible: false,
      imageList: [],
      currentIndex: 0,
      StateList: [], // 州
      siteList: [],
      userList: [],
      searchsiteStr: '',
      seachDriver: '',
      selectDataList: [],
      tipDialog1: false,
      resultsObj: {},
      exceptionTypeList: []
    };
  },
  computed: {
    IsWidth01() {
      return {
        width: this.isTormat ? '210px' : '130px'
      };
    }
  },
  created() {
    if (this.$i18n.locale !== 'zh') {
      this.isTormat = true;
    }
    this.getTimer();
    this.getSearch();
    this.getExceptionTypeList();
    this.getRegion();
    this.getCustomerPage();
  },
  methods: {
    clickEvent() {
      this.$refs.reportEventRef.showEventDialog();
    },
    // 查询条件整理
    queryParam() {
      const params = {
        startTime: null,
        endTime: null,
        regions: this.queryForm.params.regions,
        processes: this.queryForm.params.processes,
        eventType: this.queryForm.params.eventType,
        timeType: this.queryForm.params.timeType,
        exceptionTypeList: this.queryForm.params.exceptionTypeList,
        approveStatusList: this.queryForm.params.approveStatusList,
        regionId: this.queryForm.params.regionId,
        reportUser: this.queryForm.params.reportUser
      };
      if (this.timeValue && this.timeValue.length > 0) {
        params.startTime = this.timeValue[0];
        params.endTime = this.timeValue[1];
      }
      return params;
    },
    // 查询
    getSearch() {
      const data = {
        pageSize: this.queryForm.pageSize,
        pageNumber: this.queryForm.pageNumber,
        params: {}
      };
      data.params = this.queryParam();
      if (!this.timeValue || this.timeValue.length === 0) {
        this.$message.warning(this.$t('fixDutyFine.selectTimeRange'));
        return;
      }
      getExceptionReportPage(data).then((res) => {
        if (res.code === 200) {
          this.queryForm.total = res.data.total;
          this.tableData = res.data.records;
        }
      });
    },
    // 重置
    resetForm() {
      this.queryForm.pageNumber = 1;
      this.getTimer();
      this.queryForm.params = {
        inputValue: '',
        selectType: 1,
        selectStateType: 1,
        timeType: 1,
        selectSiteType: 1,
        preState: []
      };
      this.searchsiteStr = '';
      this.seachDriver = '';
      this.siteList = [];
      this.userList = [];
      this.getSearch();
    },
    // 大区
    getRegion() {
      regionQueryList('').then((res) => {
        if (res.code === 200) {
          this.regionList = res.data;
        }
      });
    },
    // 异常类型下拉框
    getExceptionTypeList() {
      getExceptionType().then((res) => {
        if (res.code === 200) {
          this.exceptionTypeList = res.data;
        }
      });
    },
    // 点击查看详情
    seeDetail(row) {
      this.$refs.eventApprovalRef.showApprovalDrawer(row, 2);
    },
    // 点击审批
    toApprove(row) {
      this.$refs.eventApprovalRef.showApprovalDrawer(row, 1);
    },
    toEdit(row) {
      this.$refs.reportEventRef.showEventDialog(row);
    },
    enterSearch() {
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    // 点击分页
    handleSizeChange(val) {
      this.queryForm.pageSize = val;
      this.queryForm.pageNumber = 1;
      this.getSearch();
    },
    handleCurrentChange(val) {
      this.queryForm.pageNumber = val;
      this.getSearch();
    },
    clickDown(row) {
      console.log(row, 'clickDown');
      exportWaybillDownload(row.id).then((res) => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    // 获取最近一星期时间
    getTimer() {
      const day = new Date();
      const brazilTime = day.toLocaleString('en-US', { timeZone: 'America/Sao_Paulo' });
      const today = dayjs(brazilTime).format('YYYY-MM-DD');
      const oneWeekAgo = dayjs(brazilTime).subtract(6, 'day').format('YYYY-MM-DD');
      this.timeValue = [oneWeekAgo + ' 00:00:00', today + ' 23:59:59'];
    },
    // 获取派送员
    getCustomerPage(name = '') {
      const param = {
        pageSize: 20,
        pageNumber: 1,
        params: {
          username: name
        }
      };
      getUserPage(param).then((res) => {
        if (res.code === 200) {
          this.userList = res.data.records;
        }
      });
    },
    handleVisibleChange(val) {
      if (val === false) {
        this.getCustomerPage('');
      }
    },
    // 州
    getAddress() {
      const params = {
        level: 0,
        parentId: ''
      };
      getLgAreaListData(params, false).then((res) => {
        if (res.code === 200) {
          this.StateList = res.data.map((item) => {
            return {
              id: item.id,
              label: `${item.nameEn}`
            };
          });
        }
      });
    }
  }
};
</script>

<style scoped>
.app-container >>> .selectLabel .el-input__inner {
  height: 28px !important;
  line-height: 28px !important;
  border: none;
  font-weight: bold;
  text-align: left;
  padding: 0;
}

.app-container >>> .selectLabel .el-input__icon {
  line-height: 28px !important;
}

.selectType ::v-deep.el-input--suffix .el-input__inner {
  border: none !important;
  font-weight: bold;
  font-size: 14px;
  text-align: left;
}

.verifier {
  color: #409eff;
  cursor: pointer;
  padding: 0;
  font-size: 18px;
}
</style>
